import axios from "axios";
import home from "../../home/home";
import {
  calculateTimeDifferenceTwoDates,
  geDataFormat,
  logOut,
} from "../../../common/utils";
import jwt_decode from "jwt-decode";
import { error } from "jquery";

export default class DashboardSanzioneService {
  getDataChart(onSuccess) {
    var dataChart = [
      {
        name: "13/12/21",
        uv: 150,
      },
      {
        name: "14/12/21",
        uv: 110,
      },
      {
        name: "15/12/21",
        uv: 170,
      },
      {
        name: "16/12/21",
        uv: 180,
      },
      {
        name: "17/12/21",
        uv: 90,
      },
      {
        name: "18/12/21",
        uv: 0,
      },
      {
        name: "19/12/21",
        uv: 0,
      },
    ];
    onSuccess(dataChart);
  }

  getSettings(onSuccess) {
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    let host = process.env.REACT_APP_API_URL;
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      }
    };
   axios.get(host+"/api/v1/impostazioni/find/imp", configHeaders).then(function(result){
      if(result.status === 401){
        logOut();
      }
        onSuccess(result.data);
    }, function(error){
     if(error.response.status === 401){
        logOut();
      }
        console.log("Errore di  "+error);
        onSuccess("");
    });
  }

  getInspectors(onSuccess){
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios.get(host + "/api/v1/user/find/", configHeaders).then(
      function (result) {
        let inspectorsList = [];
        if(result.status === 401){
          logOut();
        } else if(result.status === 200) {
          inspectorsList = result.data.filter((result) => result.ruoliOperatori.nomeRuolo === "0").map((data) => {
            return {
              nome: data.nome,
              cognome: data.cognome,
              numMatricola: data.numMatricola,
              email: data.email
            };
          });
        }
        onSuccess(inspectorsList);
      },
      function (error) {
        if(error.response.status === 401){
          logOut();
        }
        console.log("errore ricerca composizione " + error);
        onSuccess([]);
      }
    )
  }

  getDataTableSanzioni(stato, dataInizio, dataFine, onSuccess) {
    var headerDataTableSanzione = [
      {
        label: "Num. Sanzione",
        field: "numeroSanzione",
        width: 100,
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
        },
      },
      { label: "Controllore", field: "matricolaControllore", width: 270 },
      { label: "Data Emissione", field: "dataEmissione", width: 270 },
      { label: "Importo", field: "importo", width: 270 },
      { label: "Stato", field: "statoSanzione", width: 270 },
      { label: "Nome", field: "nome", width: 270 },
      { label: "Cognome", field: "cognome", width: 270 },
      {
        label: "Giorni alla scadenza",
        field: "giorniAllaScadenza",
        width: 270,
      },
      { label: "Stato Eta", field: "minorenne", width: 270 },
    ];
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    const dataOreInizio =  new Date().setDate(new Date().getDate() - 62);
    const dataOraCorrettaInizio  = new Date(dataOreInizio).setHours(0, 0, 0);

    dataInizio === ""
      ? (dataInizio = dataOraCorrettaInizio)
      : (dataInizio = +new Date(dataInizio).setHours(0, 0, 0));
    dataFine === ""
      ? (dataFine = +new Date().setHours(23,59, 59))
      : (dataFine = +new Date(dataFine).setHours(23,59, 59));

    // console.log(new Date(dataFine));
    // console.log(new Date(dataInizio));


    axios
      .get(
        host +
          "/api/v1/sanzione/findAll/" +
          stato +
          "/" +
          dataInizio +
          "/" +
          dataFine,
        configHeaders
      )
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(headerDataTableSanzione, result.data);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log("errore ricerca composizione " + error);
          onSuccess(headerDataTableSanzione, []);
        }
      );
  }

  saveFine(fine,onSucces,onError){
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
    .post(host + "/api/v1/sanzione/save",fine,configHeaders)
    .then((result)=>{
      if(result.status === 200){
        onSucces();

      }else if(result.status === 401){
        logOut();
      }else{
        onError()
      }
    },
    (error)=>{
      onError();
    })
  }

  getTipoSanzione(onSuccess) {
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    let host = process.env.REACT_APP_API_URL;
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        // CF:"92004770134",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    // console.log(JSON.stringify(jsonSanzione));
    axios.get(host + "/api/v1/tipologiaSanzione/find/", configHeaders).then(
      function (result) {
        // console.log(result.status);
        // onSuccess(result.data);
        if(result.status === 401){
          logOut();
        }
        onSuccess(result);
      },
      function (error) {
        if(error.response.status === 401){
          logOut();
        }
        console.log("Errore di  " + error);
        onSuccess("");
      }
    );
  }

  getExportCSV(stato, dataInizio, dataFine, onSuccess) {
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    let host = process.env.REACT_APP_API_URL;
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        // CF:"92004770134",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    // console.log(JSON.stringify(jsonSanzione));
    const dataOreInizio =  new Date().setDate(new Date().getDate() - 62);
    const dataOraCorrettaInizio  = new Date(dataOreInizio).setHours(0, 0, 0);

    dataInizio === ""
      ? (dataInizio = dataOraCorrettaInizio)
      : (dataInizio = +new Date(dataInizio).setHours(0, 0, 0));
    dataFine === ""
      ? (dataFine = +new Date().setHours(23,59, 59))
      : (dataFine = +new Date(dataFine).setHours(23,59, 59));
    axios
      .get(host + "/api/v1/sanzione/esportaSanzioni/" + stato + "/" + dataInizio + "/" + dataFine, configHeaders)
      .then(
        function (result) {
          // console.log(result.status);
          // onSuccess(result.data);
          if(result.status === 401){
            logOut();
          }
          onSuccess(result);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log("Errore di  " + error);
          onSuccess("");
        }
      );
  }
  getListLocalita(onSuccess) {
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    let host = process.env.REACT_APP_API_URL;
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        // CF:"92004770134",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    // console.log(JSON.stringify(jsonSanzione));
    axios.get(host + "/api/v1/tratta/listaLocalita", configHeaders).then(
      function (result) {
        // console.log(result.status);
        // onSuccess(result.data);
        if(result.status === 401){
          logOut();
        }
        onSuccess(result);
      },
      function (error) {
        if(error.response.status === 401){
          logOut();
        }
        console.log("Errore di  " + error);
        onSuccess("");
      }
    );
  }
  getRateScadute(onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .get(
        host + `/api/v1/sanzione/getSanzioniConRateScadute/`,
        configHeaders
      )
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log("errore ricerca dettaglio sanzione " + error);
          onSuccess();
        }
      );
  }
  getIdSanzioneByNumSanzione(numeroSanzione,onSuccess) {
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .get(
        host + `/api/v1/sanzione/getidSanzione/${numeroSanzione}`,
        configHeaders
      )
      .then(
        function (result) {
          if(result.status === 401){
            logOut();
          }
          onSuccess(result);
        },
        function (error) {
          if(error.response.status === 401){
            logOut();
          }
          console.log("errore ricerca dettaglio sanzione " + error);
          onSuccess();
        }
      );
  }

  getTotaleSanzioniByTime(datafrom, datato, onSuccess){
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .get(
        host + `/api/v1/dashboard/numero/sanzioni/${datafrom}/${datato}`,
        configHeaders
      ).then((result)=>{
        if(result.status === 401){
          logOut();
        }
        if(result.status === 200){
          onSuccess(result.data);
        }
      },
      (error)=>{
        console.log("" + error);
      })


  }

  getTotaleIngiunzioniByTime(datafrom,datato, onSuccess){
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .get(
        host + `/api/v1/dashboard/numero/ingiunzioni/${datafrom}/${datato}`,
        configHeaders
      ).then((result)=>{
        if(result.status === 401){
          logOut();
        }
        if(result.status === 200){
          onSuccess(result.data);
        }
      },
      (error)=>{
        console.log("" + error);
      })

  }

  getDettagliIncassoByTime(onSuccess){
    let host = process.env.REACT_APP_API_URL;
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var decoded = jwt_decode(objUser.token);
    const configHeaders = {
      headers: {
        Authorization: "Bearer " + objUser.token,
        CF: decoded.CFA,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };
    axios
      .get(
        host + `/api/v1/dashboard/incasso`,
        configHeaders
      ).then((result)=>{
        if(result.status === 401){
          logOut();
        }
        if(result.status === 200){
          onSuccess(result.data);
        }
      },
      (error)=>{
        console.log("" + error);
      })

  }
}
